<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dEbxwX/tc-custom/9783985311774.jpg?1703042201829" alt="This image is the cover for the book On Heroes, Hero-Worship, and the Heroic in History, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On Heroes, Hero-Worship, and the Heroic in History, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>On Heroes, Hero-Worship, and The Heroic in History is a book by Thomas Carlyle, published by James Fraser, London, in 1841. It is a collection of six lectures given in May 1840 about prominent historical figures. It lays out Carlyle's belief in the importance of heroic leadership.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Carlyle
      </h2>
      
      <p class="authorDescription body article">Thomas Carlyle (4 December 1795 – 5 February 1881) was a Scottish historian, satirical writer, essayist, translator, philosopher, mathematician, and teacher. In his book On Heroes, Hero-Worship, and The Heroic in History (1841), he argued that the actions of the "Great Man" play a key role in history, claiming that "the history of the world is but the biography of great men". Other major works include The French Revolution: A History, 3 vols (1837) and The History of Friedrich II of Prussia, Called Frederick the Great, 6 vols (1858–65). His 1837 history of The French Revolution was the inspiration for Charles Dickens' 1859 novel A Tale of Two Cities, and remains popular today. Carlyle's 1836 Sartor Resartus is a notable philosophical novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?181578a8